import React from "react";
import styles from "./Invitation.module.css";

const Invitation: React.FC = () => {
  return (
    <div className={styles.container}>
      <div className={styles.invitation}>
        <div className={styles.content}>
          <p className={styles.header}>
            A | B
          </p>
          <h1 className={styles.names}>
            Ashley Ann Smith
            <br />
            <span className={styles.and}>and</span>
            <br />
            Brantley Eric Kortman
          </h1>
          <p className={styles.body}>
            request the pleasure of your company
            <br />
            at the ceremony and celebration
            <br />
            of their marriage
          </p>
          <p className={styles.dateAndLocation}>
            Sunday, May 25, 2025
            <br />
            at five o'clock in the evening
            <br />
            Sofia Ballroom | Pasadena, California
          </p>
          <p className={styles.attire}>
            Black tie encouraged / formal attire
            <br />
            Reception to follow
          </p>
          <a className={styles.link} href="https://www.theknot.com/us/ashley-smith-and-brantley-kortman-may-2025">
            Click here to RSVP
          </a>
          <p className={styles.footer}>
            And explore our wedding website
            <br />
            Website password: 052525
          </p>
        </div>
      </div>
    </div>
  );
};

export default Invitation;
